<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Procesamiento de Trámites</h5>
          <div class="row" style="margin: 0px 0px -10px 0px; padding: -10px;">
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Gestión: </label>
                  <select 
                    v-model="filters.gestion" 
                    class="form-select"
                    @change="fetchTramites"
                  >
                    <option v-for="year in gestionYears" :value="year">{{ year }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Tipo Trámite: </label>
                  <select 
                    v-model="filters.tipo_etapa" 
                    class="form-select"
                    @change="fetchTramites"
                  >
                    <option value="">Todos</option>
                    <option value="1">Tramite Comun</option>
                    <option value="2">Juridico Legal</option>
                    <option value="3">Firma Direccin</option>
                    <option value="4">Venta Valores</option>
                    <option value="5">Min. Educacion</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Etapa: </label>
                  <select 
                    v-model="filters.etapa" 
                    class="form-select"
                    @change="fetchTramites"
                    :disabled="loadingEtapas"
                  >
                    <option value="">Todas</option>
                    <template v-if="!loadingEtapas">
                      <option v-for="etapa in etapasFiltradas" :value="etapa.id">{{ etapa.descripcion }}</option>
                    </template>
                    <option v-else disabled>Cargando etapas...</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Estado: </label>
                  <select 
                    v-model="filters.estado" 
                    class="form-select"
                    @change="fetchTramites"
                  >
                    <option value="Recibido">Recibido</option>
                    <option value="Aprobado">Aprobado</option>
                    <option value="Observado">Observado</option>
                    <option value="Rechazado">Rechazado</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-2">
              <BButton
                variant="info"
                class="btn-round btn-sm"
                @click="clearFilters"
              >
                <i class="fa fa-times"></i> Limpiar Filtros
              </BButton>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 mt-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Código:</label>
                  <input
                    type="text"
                    v-model="filters.codigo"
                    class="form-control"
                    placeholder="código..."
                    @input="debouncedFetchTramites"
                  />
                </div>
              </div>
            </div>
            
            <div class="col-md-3 mt-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Solicitante:</label>
                  <input
                    type="text"
                    v-model="filters.solicitante"
                    class="form-control"
                    placeholder="Nombre o carnet..."
                    @input="debouncedFetchTramites"
                  />
                </div>
              </div>
            </div>
            
            <div class="col-md-2 mt-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label"> De: </label>
                  <input
                    type="date"
                    v-model="filters.fecha_desde"
                    class="form-control"
                    @change="fetchTramites"
                  />
                </div>
              </div>
            </div>
            
            <div class="col-md-2 mt-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label"> a: </label>
                  <input
                    type="date"
                    v-model="filters.fecha_hasta"
                    class="form-control"
                    @change="fetchTramites"
                  />
                </div>
              </div>
            </div>

            <!-- Botón para limpiar filtros -->
            <div class="col-md-3 mt-2">
              <div class="btn-group">
                <BButton
                  variant="success"
                  class="btn-round btn-sm"
                  @click="fetchTramites"
                >
                  <i class="fa fa-search"></i> Listar Tramites
                </BButton>
                <!--
                <BButton
                  variant="danger"
                  class="btn-round btn-sm"
                  @click="generatePDF"
                >
                  <i class="fa fa-file-pdf me-1"></i> PDF
                </BButton>
                -->
                <BButton
                  variant="danger"
                  class="btn-round btn-sm me-2"
                  @click="generateSelectedPDF"
                  :disabled="selectedTramites.length === 0"
                >
                  <i class="fa fa-print me-1"></i> PDF Derivar
                </BButton>
              </div>
            </div>
          </div>
          
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                <thead class="text-primary">
                  <tr style="line-height: 8px;">
                    <th>CHK</th>
                    <th>Código</th>
                    <th>Tipo Trámite</th>
                    <th>Solicitante</th>
                    <th>Etapa</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tramite in tramites" :key="tramite.id">
                    <td>
                      <input 
                        type="checkbox" 
                        v-model="selectedTramites" 
                        :value="tramite.id"
                        class="form-check-input"
                      >
                    </td>
                    <td>{{ tramite.codigo }}</td>
                    <td>{{ tramite.tipo_tramite }}</td>
                    <td>{{ tramite.solicitante }}</td>
                    <td>{{ tramite.etapa_actual }}</td>
                    <td>
                      <BBadge :variant="getEstadoBadge(tramite.estado)">
                        {{ tramite.estado }}
                      </BBadge>
                    </td>
                    <td>{{ tramite.fecha_actual }}</td>
                    <td>
                      <div class="btn-group">
                        <router-link 
                          :to="`/tramite/detail/${tramite.id}`" 
                          class="btn btn-sm btn-info"
                        >
                          <i class="fa fa-eye"></i>
                        </router-link>
                        <BButton
                          v-if="showActionButton(tramite)"
                          @click="showActionModal(tramite)"
                          variant="primary"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-cog"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-6">
                <div class="text-muted small">
                  Mostrando {{ (pagination.current_page - 1) * pagination.per_page + 1 }} a 
                  {{ Math.min(pagination.current_page * pagination.per_page, pagination.total) }} de 
                  {{ pagination.total }} registros
                </div>
              </div>
              <div class="col-md-6">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @update:model-value="handlePageChange"
                  align="end"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para procesar trámite -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <template v-if="currentTramite.id">
        <form @submit.prevent="handleSubmit">
          <div class="row mt-3">
            <label class="form-label col-md-2">Código:</label>
            <div class="col-md-4">
              <input
                type="text"
                v-model="currentTramite.codigo"
                class="form-control"
                readonly
              />
            </div>
            <label class="form-label col-md-2">Etapa:</label>
            <div class="col-md-4">
              <input
                type="text"
                v-model="currentTramite.etapa_actual"
                class="form-control"
                readonly
              />
            </div>
          </div>
          
          <div class="row mt-3">
            <label class="form-label col-md-2">Acción:</label>
            <div class="col-md-10">
              <select 
                class="form-select" 
                v-model="form.accion"
                @change="handleAccionChange"
              >
                <option value="">Seleccione una acción</option>
                <option v-for="accion in accionesDisponibles" :value="accion.value">{{ accion.label }}</option>
              </select>
            </div>
          </div>
          
          <div class="row mt-3" v-if="showObservacionField">
            <label class="form-label col-md-2">Observación:</label>
            <div class="col-md-10">
              <textarea
                v-model="form.observacion"
                class="form-control"
                rows="3"
                required
              ></textarea>
            </div>
          </div>
          
          <div class="row mt-3" v-if="showEntregadoAField">
            <label class="form-label col-md-2">Entregado a:</label>
            <div class="col-md-10">
              <select 
                class="form-select" 
                v-model="form.id_entregadoa"
                required
              >
                <option value="">Seleccione persona</option>
                <option 
                  v-for="persona in personas" 
                  :key="persona.id" 
                  :value="persona.id"
                >
                  {{ persona.nombres }} {{ persona.paterno }} {{ persona.materno }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-footer mt-3">
            <BButton
              type="button"
              variant="secondary"
              @click="modalVisible = false"
              class="me-2"
            >
              Cancelar
            </BButton>
            <BButton
              type="submit"
              variant="primary"
              :disabled="loadingForm || !form.accion"
            >
              <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Confirmar
            </BButton>
          </div>
        </form>
      </template>
      <template v-else>
        <div class="text-center p-4">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Cargando trámite...</span>
          </div>
        </div>
      </template>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed, watch } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge, BPagination } from 'bootstrap-vue-3';

interface Etapa {
  id: number;
  tipo_etapa: number;
  descripcion: string;
  orden: number;
  rol_usuario: string;
}

interface Tramite {
  id: number;
  codigo: string;
  tipo_tramite: string;
  solicitante: string;
  etapa_actual: string;
  estado: string;
  fecha_actual: string;
  tipo_etapa: number;
  id_etapa_actual: number;
}

interface FormData {
  accion: string;
  observacion: string;
  id_entregadoa: number | null;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

interface Filters {
  gestion: number;
  tipo_etapa: string;
  etapa: string;
  estado: string;
  codigo: string;
  solicitante: string;
  fecha_desde: string;
  fecha_hasta: string;
}

const defaultTramite: Tramite = {
  id: 0,
  codigo: '',
  tipo_tramite: '',
  solicitante: '',
  etapa_actual: '',
  estado: '',
  fecha_actual: '',
  tipo_etapa: 0,
  id_etapa_actual: 0
};

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BPagination
  },
  setup() {
    const authStore = useAuthStore();
    const tramites = ref<Tramite[]>([]);
    const loading = ref(true);
    const etapas = ref<Etapa[]>([]);
    const loadingEtapas = ref(false);
    const currentTramite = ref<Tramite>({ ...defaultTramite });
    const personas = ref([]);
    const loadingPersonas = ref(false);
    const selectedTramites = ref<number[]>([]);
    
    // Filtros
    const filters = ref({
      gestion: new Date().getFullYear(),
      tipo_etapa: '',
      etapa: '',
      estado: 'Recibido',
      codigo: '',
      solicitante: '',
      fecha_desde: '',
      fecha_hasta: ''
    });
    
    const gestionYears = ref([
      new Date().getFullYear() - 1,
      new Date().getFullYear(),
      new Date().getFullYear() + 1
    ]);
    
    // Variables para el modal
    const modalVisible = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});
    
    const form = ref<FormData>({
      accion: '',
      observacion: '',
      id_entregadoa: null
    });
    
    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 15,
      total: 0,
      last_page: 1
    });
    
    let searchTimer: NodeJS.Timeout | null = null;

    // Computed properties
    const etapasFiltradas = computed(() => {
      if (!Array.isArray(etapas.value) || !filters.value.tipo_etapa) {
        return [];
      }
      return etapas.value.filter(e => e.tipo_etapa.toString() === filters.value.tipo_etapa.toString());
    });
    
    const modalTitle = computed(() => {
      return currentTramite.value.id 
        ? `Procesar Trámite ${currentTramite.value.codigo}` 
        : 'Procesar Trámite';
    });
    
    const showObservacionField = computed(() => {
      return ['observar', 'rechazar'].includes(form.value.accion);
    });
    
    const showEntregadoAField = computed(() => {
      return ['entregar', 'devolver'].includes(form.value.accion);
    });
    
    const accionesDisponibles = computed(() => {
      if (!currentTramite.value.id_etapa_actual) return [];
      
      const etapa = etapas.value.find(e => e.id === currentTramite.value.id_etapa_actual);
      if (!etapa) return [];
      
      const acciones = [];

      const userRoles = authStore.user.roles || [];
      if (userRoles.length === 0) {
        return false;
      }
      const hasRequiredRole = userRoles.some(role => 
        role?.toString()?.trim()?.toLowerCase() === etapa.rol_usuario
      );

      //const userRole = authStore.user?.rol;
      
      //if (userRole === etapa.rol_usuario) {
      if (hasRequiredRole) {
        switch (etapa.descripcion) {
          case 'Recepcion':
          case 'Inicio':
            acciones.push({ value: 'aceptar', label: 'Aceptar' });
            acciones.push({ value: 'rechazar', label: 'Rechazar' });
            break;
          case 'Evaluacion':
          case 'Aprobacion':
          case 'Legal':
          case 'Firma':
          case 'Ministerio':
            acciones.push({ value: 'aprobar', label: 'Aprobar' });
            acciones.push({ value: 'observar', label: 'Observar' });
            break;
          case 'Entrega':
            acciones.push({ value: 'entregar', label: 'Entregar' });
            acciones.push({ value: 'devolver', label: 'Devolver' });
            break;
          case 'Archivo':
            acciones.push({ value: 'archivar', label: 'Archivar' });
            break;
        }
      }
      
      return acciones;
    });
    
    // Methods
    const fetchEtapas = async () => {
      loadingEtapas.value = true;
      try {
        const response = await axios.get('/tramites/etapas');
        // Asegurarnos que la respuesta es un array
        etapas.value = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        console.error('Error al cargar etapas:', error);
        etapas.value = []; // Asegurar que siempre sea un array
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las etapas de trámites'
        });
        } finally {
        loadingEtapas.value = false;
      }
    };
    
    const fetchPersonas = async () => {
      loadingPersonas.value = true;
      try {
        const response = await axios.get('/persona/select');
        personas.value = response.data;
      } catch (error) {
        console.error('Error al cargar personas:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las personas'
        });
      } finally {
        loadingPersonas.value = false;
      }
    };
    
    const fetchTramites = async () => {
      loading.value = true;
      try {
        const params = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page,
          ...filters.value,
          rol_usuario: authStore.user?.rol
        };
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });  
        const response = await axios.get('/tramites/procesamiento', { params });
        tramites.value = response.data.data;
        
        pagination.value = {
          current_page: response.data.current_page,
          per_page: response.data.per_page,
          total: response.data.total,
          last_page: response.data.last_page
        };
      } catch (error) {
        console.error('Error al cargar trámites:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los trámites'
        });
      } finally {
        loading.value = false;
      }
    };
    
    const clearFilters = () => {
      filters.value.gestion = new Date().getFullYear();
      filters.value.tipo_etapa = '';
      filters.value.etapa = '';
      filters.value.estado = 'Recibido';
      filters.value.codigo = '';
      filters.value.solicitante = '';
      filters.value.fecha_desde = '';
      filters.value.fecha_hasta = '';
      pagination.value.current_page = 1;
      fetchTramites();
    };

    const formatDate = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES');
    };

    const showActionModal = (tramite: Tramite) => {
      currentTramite.value = { ...tramite };
      form.value = {
        accion: '',
        observacion: '',
        id_entregadoa: null
      };
      modalVisible.value = true;
    };
    
    const handleAccionChange = () => {
      form.value.observacion = '';
      form.value.id_entregadoa = null;
    };
    
    const handleSubmit = async () => {
      if (!currentTramite.value.id) {
        Swal.fire('Error', 'No se ha seleccionado un trámite válido', 'error');
        return;
      }
      
      loadingForm.value = true;
      errors.value = {};
      
      try {
        const payload = {
          id_tramite: currentTramite.value.id,
          id_etapa: currentTramite.value.id_etapa_actual,
          accion: form.value.accion,
          observacion: form.value.observacion,
          id_entregadoa: form.value.id_entregadoa
        };
        
        await axios.post('/tramites/procesar', payload);
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: 'Trámite procesado correctamente'
        });
        
        modalVisible.value = false;
        fetchTramites();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar el trámite'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };
    const handlePageChange = (page: number) => {
      console.log('Cambiando a página:', page);
      pagination.value.current_page = page;
      // Forzar una nueva solicitud
      fetchTramites();
    };
    
    const getEstadoBadge = (estado: string) => {
      switch (estado) {
        case 'Aprobado': return 'success';
        case 'Observado': return 'warning';
        case 'Rechazado': return 'danger';
        default: return 'info';
      }
    };
    
    const showActionButton = (tramite: Tramite): boolean => {
      // 1. Verificar datos básicos
      if (!tramite) {
        return false;
      }

      if (!authStore.user) {
        return false;
      }

      // 2. Verificar roles del usuario (ahora es un array)
      const userRoles = authStore.user.roles || [];
      if (userRoles.length === 0) {
        return false;
      }

      // 3. Verificar etapas disponibles
      if (!Array.isArray(etapas.value)) {
        return false;
      }

      // 4. Buscar etapa actual del trámite
      const etapaActual = etapas.value.find(e => e.id === tramite.id_etapa_actual);
      if (!etapaActual) {
        return false;
      }

      // 5. Verificar rol requerido para la etapa
      const requiredRol = etapaActual.rol_usuario?.toString()?.trim()?.toLowerCase();
      if (!requiredRol) {
        return false;
      }

      // 6. Comparar roles
      const hasRequiredRole = userRoles.some(role => 
        role?.toString()?.trim()?.toLowerCase() === requiredRol
      );

      if (!hasRequiredRole) {
        return false;
      }

      // 7. Verificar estado del trámite
      const tramiteEstado = tramite.estado?.toString()?.trim()?.toLowerCase();
      if (!tramiteEstado) {
        return false;
      }

      // 8. Lista de estados válidos
      const allowedStates = [
        'Recibido',
        'Observado'
      ].map(s => s.toLowerCase());

      if (!allowedStates.includes(tramiteEstado)) {
        return false;
      }

    return true;
  };
    const generateSelectedPDF = () => {
      if (selectedTramites.value.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Sin selección',
          text: 'Por favor seleccione al menos un trámite para generar el PDF'
        });
        return;
      }

      const params = {
        selected_ids: selectedTramites.value.join(','),
        ...(filters.value.id_unidad && { id_unidad: filters.value.id_unidad }),
        ...(filters.value.id_area && { id_area: filters.value.id_area }),
        ...(filters.value.gestion && { gestion: filters.value.gestion }),
        tipo: 'Proceso',
      };

      axios.get('/tramite/reporteTramiteSelected', {
        params,
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Abrir en nueva pestaña
        window.open(url, '_blank');
        
        // Limpiar selección después de generar
        selectedTramites.value = [];
        
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF de los trámites seleccionados'
        });
      });
    };

  const generatePDF = () => {
      const params = {
        ...filters.value,
      };
      
      axios.get('/reportes/tramites', {
        params,
        responseType: 'blob', // Esto es crucial para manejar PDFs
        headers: {
          'Accept': 'application/pdf' // Especificamos que esperamos un PDF
        }
      }).then(response => {
        // Crear el blob correctamente
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Crear enlace y descargar
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte-tramites.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar después de la descarga
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };

    // Watchers
    watch(() => filters.value.tipo_etapa, (newVal) => {
      if (newVal) {
        filters.value.etapa = '';
      }
    });
    
    // Validar fechas
    watch([() => filters.value.fecha_desde, () => filters.value.fecha_hasta], ([fechaDesde, fechaHasta]) => {
      if (fechaDesde && fechaHasta && new Date(fechaDesde) > new Date(fechaHasta)) {
        Swal.fire({
          icon: 'warning',
          title: 'Fechas inválidas',
          text: 'La fecha "desde" no puede ser mayor que la fecha "hasta"'
        });
        filters.value.fecha_hasta = '';
      }
    });

    // Lifecycle hooks
    onMounted(() => {
      fetchEtapas();
      fetchPersonas();
      fetchTramites();
    });
    
    return {
      tramites,
      loading,
      etapas,
      loadingEtapas,
      etapasFiltradas,
      currentTramite,
      personas,
      loadingPersonas,
      filters,
      gestionYears,
      form,
      errors,
      loadingForm,
      modalTitle,
      modalVisible,
      pagination,
      showObservacionField,
      showEntregadoAField,
      accionesDisponibles,
      fetchTramites,
      clearFilters,
      formatDate,
      handlePageChange,
      showActionModal,
      handleAccionChange,
      handleSubmit,
      getEstadoBadge,
      showActionButton,
      generatePDF,
      generateSelectedPDF,
      selectedTramites
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
</style>